'use client'
import HgPricingCardsStateless from './stateless'
import {useOptimisticChecked} from './utils'
import {type HgPricingCardsProps} from './types'

export default function HgPricingCardsClient({
  pricingCards,
  headingEyebrow,
  headingToggleLabel,
}: HgPricingCardsProps) {
  const {optimisticChecked, handleCheckedChange} = useOptimisticChecked()
  return (
    <HgPricingCardsStateless
      pricingCards={pricingCards}
      headingEyebrow={headingEyebrow}
      headingToggleLabel={headingToggleLabel}
      checked={optimisticChecked}
      onCheckedChange={handleCheckedChange}
    />
  )
}
